import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  listeRestaurantsSelector,
  setRestaurants,
  selectRestaurant,
  patchSelectedRestaurant,
  fetchSuperAdminRestaurants,
} from "./listeRestaurantsSlice";
import { connexionSelector } from "../connexion/connexionSlice";
import { useHistory } from "react-router-dom";
import Button from "react-bootstrap/Button";
import styles from "./ListeRestaurants.module.css";

const ListeRestaurants = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  // Récupère la liste et la sélection depuis le slice listeRestaurants
  const { restaurants, selectedRestaurant } = useSelector(listeRestaurantsSelector);

  // Récupère les infos de l'utilisateur depuis le slice connexion (dont restaurants_affichage_list)
  const { utilisateur } = useSelector(connexionSelector);

  // Au montage, charger les restaurants selon le type d'utilisateur
  useEffect(() => {
    if (restaurants.length === 0 && utilisateur) {
      if (utilisateur.type === "superadmin") {
        // Pour les superadmins, récupérer tous les restaurants via API
        dispatch(fetchSuperAdminRestaurants());
      } else if (utilisateur.restaurants_affichage_list) {
        // Pour les utilisateurs normaux, utiliser les restaurants du token
        dispatch(setRestaurants(utilisateur.restaurants_affichage_list));
      }
    }
  }, [restaurants, utilisateur, dispatch]);

  // Sélection d'un restaurant (met à jour selectedRestaurant)
  const handleSelect = (restaurant) => {
    // Empêcher la sélection de l'option séparatrice
    if (restaurant.restaurants_affichage === "separator") {
      alert("Veuillez choisir une option valide.");
      return;
    }
    dispatch(selectRestaurant(restaurant));
  };

  // Validation : envoie une requête PATCH à /compte/connexion/alias pour compléter le token
  const handleConfirm = () => {
    if (selectedRestaurant && selectedRestaurant.restaurants_affichage !== "separator") {
      // Construit le payload à envoyer au patch
      const payload = {
        id: utilisateur.id,
        restaurant: selectedRestaurant,
      };
      dispatch(patchSelectedRestaurant(payload));
      // La redirection vers /dashboard est gérée dans l'extraReducer du thunk patchSelectedRestaurant
    } else {
      alert("Veuillez sélectionner un restaurant.");
    }
  };

  // Créer la liste avec l'option séparatrice pour les superadmins
  const getDisplayRestaurants = () => {
    if (utilisateur?.type === "superadmin" && restaurants.length > 0) {
      const displayList = [];
      
      // Ajouter Administration
      const adminRestaurant = restaurants.find(r => r.restaurants_affichage === "admin");
      if (adminRestaurant) {
        displayList.push(adminRestaurant);
      }
      
      // Ajouter l'option séparatrice
      displayList.push({
        restaurants_affichage: "separator",
        restaurants_nom: "-",
        restaurants_id: "separator"
      });
      
      // Ajouter les autres restaurants (sauf Administration)
      const otherRestaurants = restaurants.filter(r => r.restaurants_affichage !== "admin");
      displayList.push(...otherRestaurants);
      
      return displayList;
    }
    return restaurants;
  };

  const displayRestaurants = getDisplayRestaurants();

  return (
    <div className={styles.div_form_restaurants}>
      <img
        className={styles.logo_restaurants}
        src={process.env.PUBLIC_URL + "/POKKYWEB_noir_L.png"}
        alt="Logo"
      />

      <h2 className={styles.title}>Sélectionnez votre restaurant</h2>

      {displayRestaurants.length === 0 ? (
        <p>Aucun restaurant trouvé.</p>
      ) : (
        <ul className={styles.restaurantList}>
          {displayRestaurants.map((restaurant, index) => (
            <li
              key={index}
              className={`
                ${styles.restaurantItem}
                ${restaurant.restaurants_affichage === "separator" ? styles.separator : ""}
                ${
                  selectedRestaurant &&
                  selectedRestaurant.restaurants_affichage === restaurant.restaurants_affichage
                    ? styles.selected
                    : ""
                }
              `}
              onClick={() => handleSelect(restaurant)}
            >
              {restaurant.restaurants_nom}
            </li>
          ))}
        </ul>
      )}

      <Button
        variant="outline-danger"
        className={styles.button_confirmation}
        onClick={handleConfirm}
      >
        Confirmer
      </Button>
    </div>
  );
};

export default ListeRestaurants;
